import { Injectable } from '@angular/core';
import constantURL from 'src/app/shared/constantURL';
import { BaseLoggedInPostService } from 'src/app/shared/services/base-logged-in-post.service';

@Injectable({
  providedIn: 'root',
})
export class ProviderListService extends BaseLoggedInPostService {
  _path = constantURL.gate.providers.list;
  async getProviders() {
    this.setParams({
      date: null,
      search: '',
      pageSize: 100000000,
      pageNumber: 1,
      sort: 'createdAt',
      sortType: 'ASC',
      columns: '',
    });
    let result = await this.make();
    return result.providers;
  }
}
